<template lang="html">
  <div class="blog-page">
    <div class="blog-banner">
      <h1>DOCKING BLOG</h1>
      <p>Resource you need to grow your shipyard</p>
    </div>

    <BlogCategory></BlogCategory>

    <b-container 

      >
      <b-row   
          v-for="blog in blogs" 
          :key="blog.id" 
          class="blog-card"
      >

          <b-col lg="6" cols="12" class="blog-text">
            <a v-bind:href="'/blog-detail/'+blog.slug">
              <h2>{{ blog.title }}</h2>
            </a>
            <a v-bind:href="'/blog/category/'+blog.categorySlug">
              <b-badge variant="warning">{{ blog.category }}</b-badge>
            </a>
            <p class="short-desc">
              {{ blog.description.substring(0,50) }} ...
              <a v-bind:href="'/blog-detail/'+blog.slug"><span class="readmore">Readmore</span></a>
            </p>
            <span class="date">
              <strong>Date Post :</strong> Jan 30, 2018
            </span>
            <!-- <div class="shareto">
              <span>share to :</span>
              <ul>
                <li>FB</li>
                <li>GL</li>
                <li>EMAIL</li>
                <li>LINK</li>
              </ul>
            </div> -->
          </b-col>
          <b-col lg="2" class="desktop-only">
          </b-col>
          <b-col lg="4" cols="12" class="blog-image">
            <img v-bind:src="blog.photo" alt="">
          </b-col>
        </a>
      </b-row>
      
      <!-- <b-row class="blog-card">
        <b-col lg="6" cols="12" class="blog-text">
          <h2>How Docking.Id saved my business when it was at its lowest point.</h2>
          <b-badge variant="warning">Publication</b-badge>
          <b-badge variant="warning">Regulation</b-badge>
          <p class="short-desc">Subtitle blog ini yang malah lebih panjang. Bisa diisi dengan preview konten yang ditulis di blog nya sendiri. Seperti demikian ..
            <span class="readmore">Readmore</span>
          </p>
          <span class="date">
            Jan 30, 2018
          </span>
          <!-- <div class="shareto">
            <span>share to :</span>
            <ul>
              <li>FB</li>
              <li>GL</li>
              <li>EMAIL</li>
              <li>LINK</li>
            </ul>
          </div>
        </b-col>
        <b-col lg="2" class="desktop-only">
        </b-col>
        <b-col lg="4" cols="12" class="blog-image">
          <img src="https://source.unsplash.com/user/erondu" alt="">
        </b-col>
      </b-row> -->

    </b-container>

       <b-container>
        <b-row>
          <b-col lg="12">
            <b-pagination
              v-model="currentPage"
              :per-page="limit"
              :total-rows="allCount"

              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              size="lg"
              align="center" />
          </b-col>
        </b-row>
        <!-- <div style="color:white"> page : {{ this.$route.query }} </div> -->
        <!-- <div style="color:white"> curretPage : {{ currentPage }} </div> -->
      </b-container>

      <BlogSearchingModal></BlogSearchingModal>
  </div>
</template>


<script>

import BlogsAPI from "~/api/blogs.js"
//import BlogPaging from "~/components/blog-paging/paging"
import BlogCategory from "~/components/blog-category/index"
import BlogSearchingModal from "~/components/blog-searching-modal/index"

export default {
  layout :'default',
  data() {
      return {
        blogs:[],
        blogSlice:[],
        allCount:0,
        limit:5,
        currentPage:1,
        startItem:0,
        lastItem:0

      }
    },
  computed:{
    pageCount() {
      //console.log( "allCount", this.allCount )
      return Math.ceil(this.allCount / this.limit)
    },
   
  },
  watch:{
    "$route"(){
      // console.log( this.$route)
    },
  
  },
  methods: {
    blogSliceMethod() {
      // return this.blogSlice()
     
      this.startItem = (this.currentPage-1) * this.limit;// rumus
      this.lastItem = this.lastItem; //rumus
      // berisi perhitungan startItem, dan lastItem
      this.blogSlice = this.blogs.splice(this.startItem, this.lastItem);
      // console.log( " blogSlice => ",this.blogSlice )
    },
    fetchBlogs(){

      this.$router.push({ path: '/blog'})

      let BlogsApi = new BlogsAPI(this.$axios)

      let params = this.filters || {} // params dari object
      params.page = this.currentPage
      params.limit = 5
     
      BlogsApi.getAll().then(res => {
      
        //console.log( res.data )
        let blogs = res.data 

        blogs.forEach(data => {
          this.blogs.push(data)
        });

        //this.allCount = blogs.length
         //this.blogSliceMethod(); // panggil setelah selesai
      }).
      catch(err => {
        // console.log("error blog list => ", err)
      })
    },
    fetchAllBlogbyCategory(categorySlug) {
        
        this.$router.push({ path: `/blog/category/${categorySlug}` })

        let params = this.filters || {} // params dari object
        params.page = this.currentPage
        params.limit = 5

        //console.log( "categorySlug => ",param ); 
        let BlogsApi = new BlogsAPI(this.$axios)

       //this.$router.push({ path: 'allcount'})
        BlogsApi.getAllByCategories(categorySlug).then(res => {
        
            //console.log( res.data )
            let blogs = res.data 

            blogs.forEach(data => {
                this.blogs.push(data)
            });

        }).
        catch(err => {
            console.log("error => ", err)
        })
    },
    fetchAllBlogCount(){
      let BlogsApi = new BlogsAPI(this.$axios)

       //this.$router.push({ path: 'allcount'})
      BlogsApi.getAllCount().then(res => {
      
        //console.log( res.data )
        this.allCount = res.data

   
      }).
      catch(err => {
        // console.log("error allcount => ", err)
      })
    },
    fetchSearchBlog(keyword) {
        
        if( this.$route.query.category === undefined) {
          this.$router.push({ path: `/blog/search/${keyword}` })
        } else {
          this.$router.push({ path: `/blog/search/${keyword}?category=${this.$route.query.category}` })
        }
      

        let params = this.filters || {} // params dari object
        params.page = this.currentPage
        params.limit = 5

        //console.log( "categorySlug => ",param ); 
        let BlogsApi = new BlogsAPI(this.$axios)

       //this.$router.push({ path: 'allcount'})
        BlogsApi.getSearchBlog(keyword , `${this.$route.query.category}`).then(res => {
        
            //console.log( res.data )
            let blogs = res.data 

            blogs.forEach(data => {
                this.blogs.push(data)
            });

        }).
        catch(err => {
            // console.log("error => ", err)
        })

    }
  },
  beforeMount(){
    //console.log(" params => ",this.$params)
    let param =  this.$route.params

    if(param.category !== undefined ) {
      this.fetchAllBlogbyCategory(param.category)
    } 
    else if(param.keyword !== undefined) {
      this.fetchSearchBlog(param.keyword)
    }
    else {
      this.fetchBlogs()
      this.fetchAllBlogCount()
     
    }

   
  },
  components: {
   
    "BlogCategory":BlogCategory,
    "BlogSearchingModal":BlogSearchingModal
  }
}
</script>

<style lang="scss">
  @import '~/assets/scss/_mixins.scss';
  @import './style.scss';
</style>
